import { makeStyles } from "@material-ui/core/styles";
export const useStyles = makeStyles((theme) => ({
  title: {
    textAlign: "center",
    fontSize: 14,
    color: "green",
  },
  card: {
    width: "8em",
    height: "8em",
    boxShadow:
      "0px 4px 4px rgba(51, 51, 51, 0.04), 0px 4px 24px rgba(51, 51, 51, 0.24)",
  },
  action: {
    padding: 15,
    height: "100%",
  },
  icon: {
    height: "2em",
  },
  iconSm: {
    height: "1em",
  },
  root: {
    root: {
      width: 500,
    },
  },
  noPadding: {
    padding: "5px",
    paddingBottom: "5px",
  },
}));
